module.exports = __webpack_public_path__ + "img/python.9591ed82.png";